<div class="acceptDialogue">
  <div class="textSec d-flex flex-column">
    <span class="topHead">Are you sure you want to approve this datum?</span>
    <span class="tailEnd mt-4"
      >This is a critical action, please recheck before proceeding!</span
    >
  </div>
  <div class="actionSec mt-4">
    <div class="actionBtn d-flex justify-content-between">
      <div class="continue dp-primary-btn cursor-pointer" (click)="acceptDatum()">
        <div class="cross"></div>
        <span>Yes, Continue</span>
      </div>
      <div
        type="reset"
        class="dp-secondary-btn cancel"
        mat-button
        mat-dialog-close
      >
        <span> No, cancel </span>
      </div>
    </div>
  </div>
</div>
